import * as Gconstants from './GConstants';

export const SPOOL_LINE_WIDTH = 0.5;
export const NODE_RADIUS: number = 0.75;
export const STOPE_RADIUS: number = 3;
export const NODE_COLOUR = Gconstants.DARK_GREY;
export const STOPE_COLOUR = Gconstants.RED;
export const PIT_COLOR = Gconstants.ORANGE;
export const FRICTIONLOOP_COLOR = Gconstants.BLUE;
export const SPOOL_COLOUR = Gconstants.LIGHT_GRAY;
export const TELEMETRY_CANVAS_WIDTH = 275;

export const ACTIVE_SPOOL_LINE_WIDTH = 2;

export const PIT_RADIUS: number = 4;
export const FRICTIONLOOP_RADIUS: number = 4;
export const HOVER_RADIUS: number = 4;

export const HOVER_COLOUR = Gconstants.GREEN;

export const SPOOL_WIDTH = 1;
export const SPOOL_HIT_WIDTH = 2;
export const SPOOL_SELECTED_WIDTH = 3;
export const SPOOL_ACTIVE_WIDTH = 3;

export const SPOOL_HIT_COLOUR = Gconstants.RED;
export const SPOOL_SELECTED_COLOUR = Gconstants.GREEN;
export const SPOOL_ACTIVE_COLOUR = Gconstants.PC_BLUE;

// How far an inactive spool's colour is blended towards the scene background.
export const INACTIVE_SPOOL_FADE = 0.75;
